import Tool from "./Tool";
import NodeLayer from "./NodeLayer";
import Rect from "./Rect";
import Editor from "./Editor";
import Vector2 from "./Vector2";
import { v4 as uuidv4 } from "uuid";
import MouseEventArgs from "./MouseEventArgs";
import { createTransformToolChain } from "./toolChains";

export default class DuplicateNodeTool extends Tool {
  public constructor(editor: Editor) {
    super(editor, "duplicate_node");
  }

  public duplicate(): boolean {
    var selectedLayer = this.editor.selectedLayer;
    if (selectedLayer == null || !(selectedLayer instanceof NodeLayer)) {
      return;
    }
    const { position, size } = selectedLayer.boundingRect;
    const {
      questionText,
      questionType,
      choices,
      answer,
      answers,
      enabledName,
      finalMessage,
      redirectUrl,
      yesChoiceStyle,
      noChoiceStyle,
      choicesStyles,
      finalQuestionStatus,
      narrativeTemplate,
      referralUrlStatus,
      colorCode,
      incomingConnections,
    } = selectedLayer;

    const newPosition = position.add(new Vector2(40, 40));
    var duplicatedLayer = new NodeLayer(
      this.editor,
      uuidv4(),
      new Rect(newPosition, size)
    );
    duplicatedLayer.setAnswer(answer);
    duplicatedLayer.setAnswers(answers);
    duplicatedLayer.setChoicesStyles(choicesStyles);
    duplicatedLayer.setEnabledName(enabledName);
    duplicatedLayer.setEnabledReferralUrl(referralUrlStatus);
    duplicatedLayer.setFinalMessage(finalMessage);
    duplicatedLayer.setFinalQuestion(finalQuestionStatus);
    duplicatedLayer.setNarrativeTemplate(narrativeTemplate);
    duplicatedLayer.setNoChoiceStyle(noChoiceStyle);
    duplicatedLayer.setYesChoiceStyle(yesChoiceStyle);
    duplicatedLayer.setQuestionText(questionText);
    duplicatedLayer.setQuestionType(questionType);
    duplicatedLayer.setRedirectUrl(redirectUrl);
    duplicatedLayer.setColorCode(colorCode);
    duplicatedLayer.setChoices([...choices]);
    // duplicatedLayer.addIncomingConnection(colorCode);
    this.editor.rootLayerGroup.addLayer(duplicatedLayer);
    this.editor.setSelectedLayer(duplicatedLayer);
  }

  // public handleMouseUp(arg: MouseEventArgs): boolean {
  //   var selected = this.editor.selectedLayer;

  //   if (selected != null) {
  //     var size = selected.boundingRect.size;

  //     var minSize = new Vector2(Math.max(size.x, 100), Math.max(size.y, 100));

  //     selected.setBoundingRect(
  //       new Rect(selected.boundingRect.position, minSize)
  //     );
  //   }

  //   this.editor.setCurrentTool(createTransformToolChain(this.editor));
  //   return false;
  // }
}
